import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';

import { from, Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SignalrService } from '../services/signalr.service';

/**
 * This will append jwt token for the http requests.
 *
 * @export
 * @class JwtInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private signalrService: SignalrService) {}
  private lastJwt: string | undefined;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(environment.s3Base)) {
      request = request.clone({
        withCredentials: true,
      });
      return next.handle(request);
    }
    return from(fetchAuthSession()).pipe(
      switchMap((session) => {
        const jwt = session.tokens?.accessToken?.toString();
        if (!jwt) {
          return next.handle(request);
        }
        this.lastJwt = jwt;

        if (isDevMode()) {
          console.debug('[DEV] [JwtInterceptor] request url', request.url);
        }

        const with_auth_request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${jwt}`,
            'x-connection-id': this.signalrService.connectionId.toString(),
          },
        });
        return next.handle(with_auth_request);
      }),
      catchError((err) => {
        if (err.status === 401) {
          if (isDevMode()) {
            console.debug('[DEV] [JwtInterceptor] 401 response, retrying without auth', request.url);
          }
          return next.handle(request);
        } else if (this.lastJwt) {
          const with_auth_request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${this.lastJwt}`,
            },
          });
          return next.handle(with_auth_request);
        }
        return next.handle(request);
      }),
    );
  }
}
